import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'working_hours_records_each_week_when_60_hours'

export const dataPointDefinition = {
  retracedId: 'working_hours_records_each_week_when_60_hours',
  name: 'Working Hours Records: For each week when >60 hours occurred, what percentage of the sampled workforce was impacted?',
  description: 'Enter a decimal number. E.g., for 100% enter 1.0. For 75% enter 0.75.',
  meta: {
    slcpMeta: {
      key: 'vd-veri-37',
      number: 'VD-VERI-32',
      dataType: 'numeric-percentage',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: '',
      verificationSelectionOptList: '',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: 'vd-veri-29',
      machineShowHide: 'vd-veri-29',
      completionCondition: '',
    },
    unit: 'PERCENTAGE',
    min: 0,
    max: 100,
  },
  fieldTypeId: 'NUMBER_UOM',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'vd-veri-37', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34810,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
